// import palette from '../palette';

export default {
  containedPrimary: {
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: '#6921c4',
    },
  },
  containedSecondary: {
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: 'var(--color-secondary)',
    },
  },

  contained: {
    boxShadow:
      '0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(0,0,0,0.20)',
    backgroundColor: '#FFFFFF',
  },
  disableElevation: {
    backgroundColor: 'red',
  },
};
